export const apiConfig = {
    depService: process.env.VUE_APP_DEP_SERVICE,
    hyveService: process.env.VUE_APP_HYVE_SERVICE,
    unlockMoreService: process.env.VUE_APP_UNLOCK_MORE_SERVICE,
    productId: Number(process.env.VUE_APP_PRODUCT_ID),
    vipServiceId: Number(process.env.VUE_APP_VIP_SERVICE_ID),
    malakitesGameUrl: process.env.VUE_APP_MALAKITES_GAME_URL,
    voucherStoreUrl: process.env.VUE_APP_VOUCHER_STORE_URL,
    campaignHubService: process.env.VUE_APP_CAMPAIGN_HUB_SERVICE,
    key: process.env.VUE_APP_KEY,

    myBundleLandingUrl: process.env.VUE_APP_MY_BUNDLE_LANDING_URL || '',
}
